import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ModelPageComponent } from './model-page.component';

const routes: Routes = [
  {
    path: 'model',
    data: { name: 'Device Models', isTab: false },
    component: ModelPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModelPageRoutingModule {}
